import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getCanStartCall } from "@/features/calendar/utils/general";
import images from "@/utils/images";
import { toTitleCase } from "@/utils/filters";

const SheduleListItemDesktop = (props) => {
  const {
    provider_avatar,
    email,
    configs,
    callId,
    provider_name,
    provider_role,
    provider_username,
    menuClickHandler,
    scheduledDate,
    scheduledTime,
    allotted_time,
    timestamp,
    currentTime,
  } = props;
  let LocalScheduleTime = moment(scheduledTime, "HH:mm").format("hh:mm A");

  return (
    <div className="row no-gutters d-none d-lg-flex fs-14 align-items-center justify-content-between">
      <span className="col-1 pl-4">
        <img
          alt="provider's avatar"
          src={provider_avatar || images("./common/avatar.png")}
          width="36"
        />
      </span>
      <span className="col-2">{provider_name}</span>
      <span className="col-2">{toTitleCase(provider_role.replace("_", " "))}</span>
      <span className="col-2">{scheduledDate}</span>
      <span className="col-1">{LocalScheduleTime}</span>
      <Button
        className="Btn Btn-xs fs-12 Btn--pri col-1"
        disabled={!getCanStartCall(currentTime, timestamp, allotted_time, email, configs)}
        onClick={() => props.history.push(`/app/video-call?callId=${callId}`)}
        type="button"
        {...getAutomationDataAttr("member-schedule-join-now-button")}
      >
        Join Now
      </Button>
      <span className="col-1 pl-1">
        <img
          alt="three dots menu"
          className="cursor px-2"
          onClick={(e) => menuClickHandler(e, callId, provider_username)}
          role="button"
          src={images("./icons/three-dots-menu.svg")}
          {...getAutomationDataAttr("ScheduleThreeDotsMenuButton")}
        />
      </span>
    </div>
  );
};

export default withRouter(SheduleListItemDesktop);
